import { initials } from "../lib/format";

type Props = {
  name: string | null | undefined;
  colour: string;
  size?: "xs" | "sm" | "md" | "lg";
  title?: string;
};

const sizeMap = {
  xs: "h-5 w-5 text-[10px]",
  sm: "h-7 w-7 text-xs",
  md: "h-9 w-9 text-sm",
  lg: "h-12 w-12 text-base",
};

export function Avatar({ name, colour, size = "sm", title }: Props) {
  return (
    <span
      className={`inline-grid place-items-center rounded-full font-semibold text-white shadow-sm ${sizeMap[size]}`}
      style={{ background: colour }}
      title={title ?? name ?? undefined}
      aria-label={name ?? "User"}
    >
      {initials(name)}
    </span>
  );
}
